<template>
  <div
    class="scrollable-modal simple-scrollable-modal"
    :class="{ 'scrollable-modal--with-action-bar': !!$slots['action-bar'] }"
  >
    <v-row class="mx-0" style="max-width: 100%; width: 100%">
      <v-col cols="12" class="pl-3 pr-3 fill-height main">
        <v-row class="top-nav align-center tw-justify-center" v-if="showTitle">
          <slot name="title"> </slot>
        </v-row>
        <perfect-scrollbar
          ref="ps"
          class="content ps--scroll-y-always pr-4"
          style="max-height: 100%"
          :options="{ suppressScrollX: true, wheelPropagation: false }"
        >
          <slot name="content"> </slot>
        </perfect-scrollbar>
        <v-row
          class="action-bar"
          v-if="!!$slots['action-bar'] && showScrollableBar"
        >
          <v-col cols="12">
            <slot name="action-bar"> </slot>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { PerfectScrollbar } from 'vue2-perfect-scrollbar';

  @Component
  export default class SimpleScrollableModal extends Vue {
    @Prop({ default: true }) showScrollableBar;
    @Prop({ default: true }) showTitle;

    async created() {}
  }
</script>
